"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MartiniGlassSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M26.45 7.678c.591-.64.137-1.678-.735-1.678H22.12l1.698-2.426a1 1 0 0 0-1.638-1.147L19.679 6H6.283c-.872 0-1.326 1.038-.735 1.678l9.454 10.242A1.004 1.004 0 0 0 15 18v8h-4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2h-4v-8c0-.027 0-.053-.003-.08L26.45 7.678zM19.32 10h2.265l1.846-2H20.72l-1.4 2zm-1.041-2-1.4 2h-6.466L8.567 8h9.712z" clip-rule="evenodd" stroke="none"></path>';
var MartiniGlassSVG = function MartiniGlassSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MartiniGlassSVG = MartiniGlassSVG;
MartiniGlassSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MartiniGlassSVG);
exports.default = _default;